import { api } from './client'

export const authApi = {
    register: (username, email, password, firstName, lastName, city, country, language, dateOfBirth) =>
        api.post('/auth/register', {
            username,
            email,
            password,
            first_name: firstName,
            last_name: lastName,
            city,
            country,
            language,
            date_of_birth: dateOfBirth,
        }),

    login: (username, password) =>
        api.post('/auth/login', { username, password }),

    me: () => api.get('/auth/me'),

    updateProfile: ({ firstName, lastName, city, country, language, newPassword }) =>
        api.put('/auth/me', {
            first_name:   firstName,
            last_name:    lastName,
            city,
            country,
            language,
            new_password: newPassword || null,
        }),
}
